/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC } from "react";
import ConfirmationModal from "../../../molecules/modals/ConfirmationModal";
import { useFormattedMsg } from "../../../../hooks/useFormatMsg";
import { ConfirmModalDescriptor } from "./types";

export type Props = {
  descriptor: ConfirmModalDescriptor;
};

const GlobalConfirmModal: FC<Props> = ({ descriptor }) => {
  const fallbackTitle = useFormattedMsg("confirmation.confirmAction");

  const { title, resolve, text } = descriptor;

  const handleAccept = (): void => resolve(true);
  const handleDecline = (): void => resolve(false);

  return (
    <ConfirmationModal
      accept={handleAccept}
      decline={handleDecline}
      toggle={handleDecline}
      title={title || fallbackTitle}
      isOpen
    >
      <p>{text}</p>
    </ConfirmationModal>
  );
};

export default GlobalConfirmModal;
export type GlobalConfirmModalProps = Props;
